import React, { useState } from 'react'
import arrowSingle from 'images/arrowSingle.svg'
import qrCodeArrowLeft from 'images/qrCodeArrowLeft.svg'
import qrCodeArrowRight from 'images/qrCodeArrowRight.svg'
import { Button, Modal } from 'antd'
import { QRCode } from 'react-qrcode-logo'

import Scanned from 'images/Scanned.svg'
import QRCodeLogoIcon from 'images/QRCodeLogo.svg'
import closeIconSvg from 'images/Crossmark.svg'

import c from 'classnames'
import './index.styl'

const BarcodeSlider = ({ barcode, category, eventName, section, table, current, isScanned, total, onNext, onPrev, isNext, isPrev, showSlider = true }) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = () => {
    setIsModalVisible(!isModalVisible)
  }

  const closePopup = () => {
    setIsModalVisible(false)
  }

  const barcodeValue = `${process.env.REACT_APP_API_BARCODE}${barcode}`
  const qrCodeSize = window.innerWidth <= 700 ? 299 : 112
  const isTableSeating = !!section && !!table
  return (
    <div className='rootBarcodeSlider'>
      <div className='whiteWrapper'>
        {!!category && <div className='categoryBadge'>{category}</div>}
        <div onClick={showModal} className='wrapperQrCodeContainer'>
          <div className={c('wrapperQrCode', { qrScanned: isScanned })}>
            <QRCode size={qrCodeSize} logoImage={isScanned ? undefined : QRCodeLogoIcon} removeQrCodeBehindLogo logoPadding={5} value={barcodeValue} />
          </div>
          <div className={c('scannedBadgeContainer', { isVisible: isScanned })}>
            <img src={Scanned} className='scannedBadge' alt=' ' />
          </div>
        </div>
      </div>
      {showSlider && (
        <div className='sliderControls'>
          <Button className='buttonPrev' onClick={onPrev} disabled={!isPrev}>
            <img src={arrowSingle} alt='' className='controlLeft' />
          </Button>
          <div className='summaryContainer'>
            <span>{current}</span>of<span>{total}</span>
          </div>
          <Button className='buttonNext' onClick={onNext} disabled={!isNext}>
            <img src={arrowSingle} alt='' className='controlRight' />
          </Button>
        </div>
      )}
      <Modal
        visible={isModalVisible}
        onCancel={closePopup}
        footer={null}
        centered
        closable={false}
        width={448}
        className='barcodeSliderModal'
        bodyStyle={{ textAlign: 'center', padding: 24, boxSizing: 'border-box' }}
        maskStyle={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <img className='closeQrCodeIcon' onClick={closePopup} src={closeIconSvg} alt='Close' style={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer' }} />
        {!!eventName && <div className={c('modalEventName', { alignLeft: isTableSeating })}>{eventName}</div>}
        <div className={c('modalDetailsRow', { fullWidth: isTableSeating })}>
          {!!section && (
            <div className='modalDetailsCol'>
              <span className='detailsTitle'>Section:</span>
              <span className='detailsValue'>{section}</span>
            </div>
          )}
          {!!category && (
            <div className='modalDetailsCol'>
              <span className='detailsTitle'>Ticket Category</span>
              <span className='detailsValue'>{category}</span>
            </div>
          )}
          {!!table && (
            <div className='modalDetailsCol'>
              <span className='detailsTitle'>Table #</span>
              <span className='detailsValue'>{table}</span>
            </div>
          )}
        </div>
        <div className='modalQrCodeContainer'>
          <div className={c('wrapperQrCode', { qrScanned: isScanned })}>
            <QRCode
              size={400}
              quietZone={0}
              logoImage={isScanned ? undefined : QRCodeLogoIcon}
              logoWidth={102}
              logoHeight={102}
              removeQrCodeBehindLogo
              logoPadding={10}
              value={barcodeValue}
            />
          </div>
          <div className={c('scannedBadgeContainer', { isVisible: isScanned })}>
            <img src={Scanned} className='scannedBadge' alt=' ' />
          </div>
        </div>
        {showSlider && (
          <div className='modalSliderControls'>
            <Button className='buttonPrev' onClick={onPrev} disabled={!isPrev}>
              <img src={qrCodeArrowLeft} alt='' />
            </Button>
            <div className='summaryContainer'>
              <span>{current}</span>of<span>{total}</span>
            </div>
            <Button className='buttonNext' onClick={onNext} disabled={!isNext}>
              <img src={qrCodeArrowRight} alt='' />
            </Button>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default BarcodeSlider
